import { statusFilter } from './status-filter';
import { OptionFormTypes } from '../../../../../../services/filtering/filter-form-render-service/option-form-types';

export const allFilterBys = [statusFilter];

export const popularFilterBys = [statusFilter];

export const criteriaOperatorsMap = {
  [OptionFormTypes.TYPE_CHECKLIST]: [{ value: 'in', displayName: 'Is' }],
};
